import { SidebarContext } from '@/common/components/sidebar/sidebar-context';
import { createContextHook } from '@/shared/react-context';

export const useSidebar = createContextHook(SidebarContext);
